import React, { useState, useEffect } from "react";
import { Slider } from "@mui/material";

const BudgetSlider = ({ min = 0, max = 10000000, step = 100000, value, onChange }) => {
  const [sliderValue, setSliderValue] = useState(value || [min, max]);

  useEffect(() => {
    if (value) {
      setSliderValue(value); // Update slider when value changes
    }
  }, [value]);

  const handleChange = (event, newValue) => {
    // Keep the first value fixed (budgetMin), only change the second value (budgetMax)
    setSliderValue([sliderValue[0], newValue[1]]);
    onChange([sliderValue[0], newValue[1]]); // Update parent state
  };

  return (
    <div style={{ width: 300, margin: "20px auto", textAlign: "center" }}>
      <h3>
        Budget: {sliderValue[0] / 100000}L - {sliderValue[1] / 100000}L
      </h3>
      <Slider
        value={sliderValue}
        onChange={handleChange}
        min={min}
        max={max}
        step={step}
        valueLabelDisplay="auto"
        marks={[
          { value: 0, label: "0L" },
          { value: 100000, label: "1L" },
          { value: 200000, label: "2L" },
          { value: 500000, label: "5L" },
          { value: 1000000, label: "10L" },
        ]}
        valueLabelFormat={(value) => `${value / 100000}L`}
      />
    </div>
  );
};

export default BudgetSlider;
